<template>
    <div>
        <div class="col-xs-3" style="height: 88%; padding:0" v-show="!loading">
            <dashboard-item-menu
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="threatForecastMenuList"
                @menuItemClicked="onMenuItemClick"></dashboard-item-menu>
        </div>
        <div class="col-xs-9" style="height: 100%; overflow: hidden">
            <div style="width:110%; height:80%; position: relative; top: -20px; left: -10px" v-show="!loading">
                <comb-world-map ref="forecastMap"></comb-world-map>
            </div>
        </div>
        <div class="playerContainer" v-show="!loading">
            <player ref="player" :ticks="playerTicks" :stopTick="stopTick" @onTickClick="onTickClick"></player>
        </div>
        <div class="week-menu" ref="weekMenuContainer" v-show="!loading">
            <week-menu ref="weekMenu"
                       :containerWidth="weekMenuContainerWidth"
                       :containerHeight="weekMenuContainerHeight"
                       @dateSelected="onDateSelected"
            ></week-menu>
        </div>
        <div class="enlarge-button grow" @click="onEnlargeClick" v-show="!loading">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'purple'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import WeekMenu from '@/components/week-menu/WeekMenu.vue'
    import CombWorldMap from '@/components/world-map/CombWorldMap'
    import Player from '@/components/player/Player.vue'
    import Constants from '@/utils/constants'
    import Common from '@/utils/Common.vue'
    import LoadingModal from "@/components/modals/LoadingModal";

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';

    import moment from 'moment-timezone';

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "rgb(117,32,250)";

    const MENU_TYPE_MALWARE_TYPE = "malware";
    const MENU_TYPE_INDUSTRY = "industry";

    const MALWARE_TYPE_ALL = "all";
    const MALWARE_TYPE_RANSOMWARE = "ransomware";
    const MALWARE_TYPE_TROJAN = "trojan";
    const MALWARE_TYPE_VIRUS = "virus";

    const INDUSTRY_ALL = "all";
    const INDUSTRY_FINANCE = "Financial";
    const INDUSTRY_TECHNOLOGY = "Technology";
    const INDUSTRY_RETAIL = "Retail";

    const LOCATION_WORLD = "world";
    const LOCATION_USA = "us";

    export default {
        name: 'malware-threat-forecast',
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        components: {
            DashboardItemMenu: DashboardItemMenu,
            Player: Player,
            WeekMenu: WeekMenu,
            CombWorldMap: CombWorldMap,
            LoadingModal: LoadingModal
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'HISTORICAL\nMALWARE\nTHREAT\nANALYSIS',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                threatForecastMenuList: [
                    {
                        type: "dropdown",
                        text: "ALL TYPES",
                        color: "white",
                        backgroundColor: "rgb(90,20,185)",
                        open: false,
                        items: [
                            {
                                text: "ALL TYPES",
                                color: "white",
                                selected: true,
                                value: null,
                                type: MENU_TYPE_MALWARE_TYPE
                            },
                            {
                                text: "RANSOMWARE",
                                color: "white",
                                selected: false,
                                value: MALWARE_TYPE_RANSOMWARE,
                                type: MENU_TYPE_MALWARE_TYPE
                            },
                            {
                                text: "TROJAN",
                                color: "white",
                                selected: false,
                                value: MALWARE_TYPE_TROJAN,
                                type: MENU_TYPE_MALWARE_TYPE
                            },
                            {
                                text: "VIRUS",
                                color: "white",
                                selected: false,
                                value: MALWARE_TYPE_VIRUS,
                                type: MENU_TYPE_MALWARE_TYPE
                            }
                        ]
                    },
                    {
                        type: "dropdown",
                        text: "ALL INDUSTRIES",
                        color: "white",
                        backgroundColor: "rgb(59,10,125)",
                        open: false,
                        items: [
                            {
                                text: "ALL INDUSTRIES",
                                color: "white",
                                selected: true,
                                value: null,
                                type: MENU_TYPE_INDUSTRY
                            },
                            {
                                text: "FINANCE",
                                color: "white",
                                selected: false,
                                value: INDUSTRY_FINANCE,
                                type: MENU_TYPE_INDUSTRY
                            },
                            {
                                text: "TECHNOLOGY",
                                color: "white",
                                selected: false,
                                value: INDUSTRY_TECHNOLOGY,
                                type: MENU_TYPE_INDUSTRY
                            },
                            {
                                text: "RETAIL",
                                color: "white",
                                selected: false,
                                value: INDUSTRY_RETAIL,
                                type: MENU_TYPE_INDUSTRY
                            }
                        ]
                    }
                    // {
                    //     type: "dropdown",
                    //     text: "WORLD",
                    //     color: "white",
                    //     backgroundColor: "rgb(31,2,62)",
                    //     open: false,
                    //     items: [
                    //         {
                    //             text: "WORLD",
                    //             color: "white",
                    //             selected: true
                    //         },
                    //         {
                    //             text: "USA",
                    //             color: "white",
                    //             selected: false
                    //         }
                    //     ]
                    // }
                ],
                weekMenuContainerWidth: 0,
                weekMenuContainerHeight: 0,
                playerTicks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],

                cachedForecastData: {},

                selectedDate: null,
                selectedStartHour: 0,
                selectedMalwareType: null,
                selectedIndustry: null,
                selectedLocation: null,
                forecast: [],
                filteredForecast: [],
                loading: false,
                stopTick: 24,
                pageName: 'Historical Threat Malware Analysis Widget'
            }
        },
        methods: {
            reset() {
                this.selectedStartHour = 0;
                this.$refs.player.reset();
                this.forecast = [];
                this.filteredForecast = [];
            },
            play() {
                this.$refs.player.play();
            },
            setWeekMenuViewBox() {
                this.weekMenuContainerWidth = $(this.$refs.weekMenuContainer).width();
                this.weekMenuContainerHeight = $(this.$refs.weekMenuContainer).height();
                this.$refs.weekMenu.setViewBox(this.weekMenuContainerWidth, this.weekMenuContainerHeight);
            },
            getMalwareForecast() {
                let log_start = Date.now();
                var params = {
                    start_date: this.selectedDate.date,
                    end_date: this.selectedDate.date,
                    industry: this.selectedIndustry,
                    malware_type: this.selectedMalwareType
                };

                this.loading = true;
                this.reset();
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/dashboard/malware/forecast", params)
                    .then(response => {
                        this.forecast = response.data.data;
                        this.filterForecast();
                        this.showForecast();
                        this.loading = false;
                        this.$emit('loaded', 'malware-threat-forecast', this.getDurationInSeconds(log_start, Date.now()));
                        this.play();
                    }, response => {
                        this.loading = false;
                    });
            },
            filterForecast() {
                if (!this.forecast) return;
                var newFilteredItems = [];
                for (let i = 0; i < this.forecast.length; i++) {
                    let item = this.forecast[i];

                    // Filter by hour
                    if (item.start_hour != this.selectedStartHour)
                        continue;

                    newFilteredItems.push(item);
                }
                this.filteredForecast = newFilteredItems;
            },
            showForecast() {
                this.$refs.forecastMap.showForecast(this.filteredForecast);
            },
            onDateSelected(date) {
                let log_start = Date.now()
                this.selectedDate = date;
                this.calculateStopTick();
                this.getMalwareForecast();
                this.saveLog(this, this.pageName, this.pageName + ' day clicked. Day name: (' + date.date+ ')', this.getDurationInSeconds(log_start, Date.now()), null);

            },
            onEnlargeClick() {
                let log_start = Date.now();
                let enLargeClicked = this.getDashboardEnlargedItem;
                if (enLargeClicked != null) {
                    this.saveLog(this, this.pageName, this.pageName + ' minimized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                else {
                    this.saveLog(this, this.pageName, this.pageName + ' maximized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            onMenuItemClick(item) {
                let log_start = Date.now();
                if (item.type == MENU_TYPE_INDUSTRY) {
                    this.selectedIndustry = item.value;
                    this.saveLog(this, this.pageName, this.pageName + ' industry clicked. Industry name: (' + item.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                else if (item.type == MENU_TYPE_MALWARE_TYPE) {
                    this.selectedMalwareType = item.value;
                    this.saveLog(this, this.pageName, this.pageName + ' type clicked. Type name: (' + item.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                this.getMalwareForecast();
            },
            onTickClick(tick) {
                this.selectedStartHour = tick;
                this.filterForecast();
                this.showForecast();
            },
            isToday(dateObject) {
                let currentDate = moment();
                return currentDate.format("YYYY/MM/DD") == dateObject.date;
            },
            calculateStopTick() {
                if (this.selectedDate == null || this.isToday(this.selectedDate)) {
                    let currentDate = moment();
                    let hour = currentDate.format("HH");
                    this.stopTick = parseInt(hour);
                }
                else {
                    this.stopTick = 24;
                }

            },
            ...mapActions([
                "setDashboardEnlargedItem"
            ])
        },
        computed: {},
        mounted() {
            this.calculateStopTick();
            this.cachedForecastData = this.getDashboardMalwareThreatForecastCache;
            this.setWeekMenuViewBox();
            this.selectedDate = this.$refs.weekMenu.getSelectedDate();
            this.getMalwareForecast();
        }
    }
</script>

<style scoped>

    .week-menu {
        position: absolute;
        width: 100%;
        height: 10%;
        bottom: 0;
        left: 0;
        max-height: 50px;
    }

    .playerContainer {
        position: absolute;
        width: 70%;
        height: 10%;
        bottom: 15%;
        left: 30%;
        max-height: 50px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/malware-threat-forecast/MalwareThreatForecast.vue